import { useTranslation } from 'next-i18next';

export type LeaderInfoType = {
    name: string;
    title: string;
    description: string;
    href: string;
    image: string;
};

const useAltiveLeaderInfo: () => LeaderInfoType[] = () => {
    const { t } = useTranslation();

    return [
        {
            name: t('who_we_are_hardy_name'),
            title: t('who_we_are_hardy_position'),
            description: t('who_we_are_hardy_experiences'),
            href: 'https://www.linkedin.com/in/hardy-liu/',
            image: '/static/images/hardy_avatar.jpg',
        },
        {
            name: t('who_we_are_nick_name'),
            title: t('who_we_are_nick_position'),
            description: t('who_we_are_nick_experiences'),
            href: 'https://www.linkedin.com/in/whynick/',
            image: '/static/images/nick_avatar.jpg',
        },
    ];
};

export default useAltiveLeaderInfo;
